/**
 * This is the main entry point into our application.
 * 
 * @class App
 */
import '../../styles/app/app.scss';
import { Global } from './sections/global';

declare global {
    interface Window { 
        app: App;
        loadModule: string;
    }
}

type AppModule = {
    new(): unknown;
};

type RouteModuleLoader = () => Promise<AppModule>;

const routeModules: { [moduleName: string]: RouteModuleLoader } = {
    careers: () => import('./sections/careers').then(({ Careers }) => Careers),
    caseStudies: () => import('./sections/case-studies').then(({ CaseStudies }) => CaseStudies),
    home: () => import('./sections/home').then(({ Home }) => Home),
    post: () => import('./sections/post').then(({ Post }) => Post),
    posts: () => import('./sections/posts').then(({ Posts }) => Posts),
    products: () => import('./sections/products').then(({ Products }) => Products),
    twodpe: () => import('./sections/twodpe').then(({ TwoDpe }) => TwoDpe),
};

class App {
    public modules:{ [className: string]: any } = {};


    /**
     * Creates an instance of App. We assign this instance to the window so
     * 
     * @memberof App
     */
    constructor() {
        window.app = this;
    }


    /**
     * Loops through our modules, and executes it if required
     * 
     * @memberof App
     */
    loadModules(targetModule: string): void {
        window.loadModule = targetModule;
        new Global();
        void this.loadRouteModule(targetModule);
    }


    /**
     * Loads the current route module only when it is needed.
     *
     * @param targetModule The module slug supplied by WordPress.
     * @memberof App
     */
    private async loadRouteModule(targetModule: string): Promise<void> {
        const loadModule = routeModules[targetModule];

        if (!loadModule) {
            return;
        }

        const Module = await loadModule();
        new Module();
    }
}

if (!window.app) {
    window.app = new App();
    window.app.loadModules(window.loadModule || '');
}
